module.exports = __webpack_public_path__ + "img/ss_neko.49895003.jpg";